import { BhVideo } from 'models/BhVideo';
import { Section } from 'components/Section';
import { useState, useEffect } from 'react';
import styles from './videoGallery.scss';
import { ClearButton } from 'components/Button';
import cn from 'classnames';
import { rm } from 'utils';

interface OwnProps {
  videos: BhVideo[];
}

export const VideoGallery = ({ videos }: OwnProps) => {
  const videoUrl = videos[0].videoUrl;
  const [currentVideo, setCurrentVideo] = useState<string>(videoUrl);
  const selectVideo = (videoUrl: string) => () => setCurrentVideo(videoUrl);

  useEffect(() => {
    setCurrentVideo(videoUrl);
  }, [videoUrl]);

  return (
    <Section title={rm('brand_content_videos')}>
      <iframe className={styles.videoFrame} frameBorder="none" src={currentVideo} />
      <div className={styles.thumbnails}>
        {videos.map(video => (
          <div
            key={video.videoId}
            className={cn(styles.thumbnail, { [styles.active]: video.videoUrl === currentVideo })}
          >
            <ClearButton key={video.id} onClick={selectVideo(video.videoUrl)}>
              <img src={video.thumbnailUrl} />
            </ClearButton>
          </div>
        ))}
      </div>
    </Section>
  );
};
